import React from 'react'
import PropTypes from 'prop-types'
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react'

const GoogleMaps = ({ google, coordinates }) => {
  const mapStyles = {
    width: '100%',
    height: '100%'
  }

  return (
    <>
      <Map
        google={google}
        // zoom={8}
        classname="da"
        style={mapStyles}
        initialCenter={{ lat: coordinates[0], lng: coordinates[1] }}
      >
        <Marker position={{ lat: coordinates[0], lng: coordinates[1] }} />
      </Map>
    </>
  )
}

export default GoogleApiWrapper({
  apiKey: process.env.GATSBY_GOOGLE_MAP_API_KEY
})(GoogleMaps)

GoogleMaps.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  google: PropTypes.object.isRequired,
  coordinates: PropTypes.arrayOf(PropTypes.number).isRequired
}
